import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { 
  Home, Building2, Clock, Settings, ClipboardList, Calendar,
  Smartphone, BarChart3, Package, AlertTriangle, LogOut, Menu, X,
  Users, Eye
} from 'lucide-react';

function Navigation({ user, onLogout }) {
  const location = useLocation();
  const [menuOpen, setMenuOpen] = useState(false);
  const isAdmin = user.role === 'admin';

  const menuItems = [
    // Tableau de bord pour tous
    { path: '/', label: 'Tableau de bord', icon: Home, roles: ['admin', 'technicien'] },
    
    // Section Admin - Gestion
    { path: '/utilisateurs', label: 'Utilisateurs', icon: Users, roles: ['admin'], section: 'Gestion' },
    { path: '/centres', label: 'Centres', icon: Building2, roles: ['admin'] },
    { path: '/types-intervention', label: 'Types d\'intervention', icon: Settings, roles: ['admin'] },
    
    // Section Technicien - Mon travail
    { path: '/pointage', label: 'Mon pointage', icon: Clock, roles: ['technicien'], section: 'Mon travail' },
    { path: '/realisation', label: 'Mes interventions', icon: Smartphone, roles: ['technicien'] },
    
    // Section Admin - Suivi
    { path: '/pointages', label: 'Consulter les pointages', icon: Eye, roles: ['admin'], section: 'Suivi' },
    { path: '/interventions', label: 'Interventions', icon: ClipboardList, roles: ['admin'] },
    { path: '/agenda-global', label: 'Agenda', icon: Calendar, roles: ['admin'] },
    
    // Section Technicien - Consultation
    { path: '/agenda', label: 'Voir l\'agenda', icon: Calendar, roles: ['technicien'], section: 'Consultation' },
    
    // Section Stocks
    { path: '/produits', label: 'Produits', icon: Package, roles: ['admin'], section: 'Stocks' },
    { path: '/stocks', label: 'Gestion du stock', icon: Package, roles: ['technicien', 'admin'] },
    { path: '/stocks/alertes', label: 'Alertes stock', icon: AlertTriangle, roles: ['admin'] },
    
    // Section Statistiques (Admin uniquement)
    { path: '/statistiques-globales', label: 'Statistiques globales', icon: BarChart3, roles: ['admin'], section: 'Statistiques' },
    { path: '/statistiques-technicien', label: 'Stats par technicien', icon: BarChart3, roles: ['admin'] },
  ];

  const visibleMenuItems = menuItems.filter(item => 
    item.roles.includes(user.role)
  );

  const isActive = (path) => {
    if (path === '/') return location.pathname === '/';
    return location.pathname.startsWith(path);
  };

  return (
    <>
      <nav className="navigation">
        <div className="nav-header">
          <div className="nav-brand">
            <h1>🚗 Brillanty</h1>
          </div>
          <button 
            className="nav-toggle"
            onClick={() => setMenuOpen(!menuOpen)}
          >
            {menuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>

        <div className={`nav-content ${menuOpen ? 'open' : ''}`}>
          <div className="nav-user">
            <div className="user-avatar">
              {user.prenom[0]}{user.nom[0]}
            </div>
            <div className="user-info">
              <p className="user-name">{user.prenom} {user.nom}</p>
              <p className="user-role">
                {user.role === 'admin' ? 'Administrateur' : 'Technicien'}
              </p>
            </div>
          </div>

          <ul className="nav-menu">
            {(() => {
              let currentSection = null;
              return visibleMenuItems.map((item, index) => {
                const Icon = item.icon;
                const showSection = item.section && item.section !== currentSection;
                if (item.section) {
                  currentSection = item.section;
                }
                
                return (
                  <React.Fragment key={item.path}>
                    {showSection && (
                      <li className="nav-section">
                        <span>{item.section}</span>
                      </li>
                    )}
                    <li>
                      <Link
                        to={item.path}
                        className={`nav-link ${isActive(item.path) ? 'active' : ''}`}
                        onClick={() => setMenuOpen(false)}
                      >
                        <Icon size={20} />
                        <span>{item.label}</span>
                      </Link>
                    </li>
                  </React.Fragment>
                );
              });
            })()}
          </ul>

          <button onClick={onLogout} className="btn-logout">
            <LogOut size={20} />
            <span>Déconnexion</span>
          </button>
        </div>
      </nav>
      {menuOpen && <div className="nav-overlay" onClick={() => setMenuOpen(false)} />}
    </>
  );
}

export default Navigation;

